<template>
    <div id="app" :class="[{'user-connected': isUserConnected, 'app-loaded': !$store.state.initialLoading, 'app-ready': $store.state.applicationReady, 'embed': isEmbed }]">
        <div id="app-container">
            <app-menu v-if="!isEmbed"></app-menu>
            <keep-alive>
                <router-view @login-start="loginStart" @login-finished="loginFinished"/>
            </keep-alive>
        </div>
    </div>
</template>

<script>
    import Menu from './layout/app-menu'
    import {mapGetters} from 'vuex'

    export default {
        name: `App`,
        components: {'app-menu': Menu},
        data() {
            return {
                ready: true // True by default except on the login vue
            };
        },
        created() {
            if (this.$route.fullPath === `/login`) {
                this.$store.dispatch(`logout`);
            } else {
                // try to get the current user with the saved token
                this.$store.dispatch(`getCurrentUser`).then(() => {
                    this.$store.state.initialLoading = false;

                    // Allow to provide a smooth transition when opening a new tab, but add nice effect after when user disconnect
                    setTimeout(() => {
                        this.$store.state.applicationReady = true;
                    }, 1000);
                });
            }
        },
        mounted() {

        },
        computed: {
            isUserConnected() {
                return this.ready === true && this.$store.getters.isAuthenticated;
            },
            ...mapGetters([
                `isAuthenticated`
            ])
        },
        methods: {
            loginStart() {
                this.ready = false;
            },
            loginFinished() {
                this.ready = true;
            }
        }
    }
</script>

<style lang="scss">
    @import "assets/style/global.scss";
    @import "assets/style/bootstrap-theme.scss";

    html,
    body {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        min-height: 100%;
    }

    body {
        background: #fafafa;
    }

    #app,
    #app-container {
        width: 100%;
        height: 100%;
    }

    @media(max-width: 576px) {
        body {
            padding: 2px;
        }

        #app-container {
            border-radius: 10px;
        }
    }
</style>
